export enum RevenueRecognitionLevel {
  Contract = "CONTRACT",
  Project = "PROJECT"
}
